module.exports = __webpack_public_path__ + "assets/img/role-type-1.96bad41c.png";